import moment from 'moment'

import { isValidDateObject } from './is-valid-date-object'
import { isValidISO8601 } from './is-valid-iso-8601'

/**
 * @deprecated Please use {@link isDateCurrentYear} instead!
 *
 * Check if the given date is within current year.
 *
 * @param {Date|string} date
 * @returns {boolean}
 */
export function isCurrentYearUTC(date) {
    if (isValidDateObject(date) || isValidISO8601(date)) {
        const toCheckDate = moment.utc(date).startOf('year')
        const now = moment.utc(new Date()).startOf('year')

        return !!(date && toCheckDate.isValid() && now.diff(toCheckDate, 'year', true) === 0)
    }
    return false
}
